// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"UploaderButton_buttonWrapper__VK1Sw","contentWrapper":"UploaderButton_contentWrapper__4qq2l","text":"UploaderButton_text__soR9q"};